export class ChangeNumOfCallHistoryEntriesToShow {
   public static readonly type = '[AgentDetailsSettings] Change number of call history entries to show';

   constructor(public brickInstanceId, public numOfCallEntriesToShow: number) {}
}

export class ChangeShowCaller {
   public static readonly type = '[AgentDetailsSettings] Change show caller';

   constructor(public brickInstanceId, public showCaller: boolean) {}
}

export class ChangeShowSkills {
   public static readonly type = '[AgentDetailsSettings] Change show skills';

   constructor(public brickInstanceId, public showSkills: boolean) {}
}

export class ChangeShowGroups {
   public static readonly type = '[AgentDetailsSettings] Change show groups';

   constructor(public brickInstanceId, public showGroups: boolean) {}
}

export class ChangeShowCallHistory {
   public static readonly type = '[AgentDetailsSettings] Change show call history';

   constructor(public brickInstanceId, public showCallHistory: boolean) {}
}

export class ChangeShowAvatar {
   public static readonly type = '[AgentDetailsSettings] Change show avatar';

   constructor(public brickInstanceId, public showAvatar: boolean) {}
}
